///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/core/viewmodels/transformers/create/arrayBuilder"/>
import * as defaults from "Core/Medius.Core.Web/Scripts/Medius/core/viewmodels/transformers/create/defaults";
import * as helpers from "Core/Medius.Core.Web/Scripts/Medius/core/viewmodels/helpers";

export = function arrayViewmodelBuilder(input:any/*, mapping, context*/) {
    if (!helpers.isArray(input)) {
        return null;
    }

    const viewmodel:any = [];

    return {
        ...defaults,
        shouldDescend: true,
        mapProperty: function (name:string, value:any) {
            viewmodel[name] = value;
        },
        finalize: function () {
            return viewmodel;
        }
    };
};